import { Component, Input } from '@angular/core';

@Component({
  selector: 'mfp-bubble',
  templateUrl: './bubble.component.html',
  styleUrls: ['./bubble.component.scss']
})
export class BubbleComponent {

  @Input() label = '';
  @Input() color: 'primary' | 'dark' | 'light' = 'primary';
  @Input() fill: 'filled' | 'clear' = 'filled';
  @Input() size: 'medium' | 'small' = 'medium';
  @Input() disabled = false;

  constructor() { }

}
